const FNV_OFFSET_BASIS = 0x811c9dc5;
const FNV_PRIME = 0x01000193;

/**
 * FNV-1a, as a base-36 string.
 *
 * Non-cryptographic and 32-bit: this is for cheaply telling one value from
 * another — cache keys, change detection, memo identity — not for integrity or
 * anything an adversary gets to choose the input to. Collisions are findable by
 * construction, and at ~65k distinct inputs a random collision is about even
 * money, so don't use it where one would be worse than a redundant fetch.
 */
export const hashString = (input: string): string => {
  let hash = FNV_OFFSET_BASIS;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, FNV_PRIME);
  }
  // `>>> 0` first: Math.imul yields a signed 32-bit int, and a negative one
  // would render with a `-` and halve the usable key space.
  return (hash >>> 0).toString(36);
};
